import { useMemo } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import GlobalProgressSummary from "@/components/GlobalProgressSummary";
import PhaseRoadmap from "@/components/PhaseRoadmap";
import PhaseTaskDetail from "@/components/PhaseTaskDetail";
import PhaseDocuments from "@/components/PhaseDocuments";

export default function ProjectRoadmap({ project, tasks, setTasks, phases, refreshProject, canEdit, selectedId, onSelect }) {
  const activePhase = useMemo(() => phases.find((p) => p.id === selectedId), [phases, selectedId]);
  const phaseTasks = useMemo(() => tasks.filter((t) => t.phase_id === selectedId), [tasks, selectedId]);

  const handleToggle = async (task, completed) => {
    setTasks((ts) => ts.map((t) => (t.task_id === task.task_id ? { ...t, completed } : t)));
    try {
      await api.patch(`/tasks/${task.task_id}`, { completed });
      await refreshProject();
    } catch {
      toast.error("No se pudo actualizar la tarea.");
      setTasks((ts) => ts.map((t) => (t.task_id === task.task_id ? { ...t, completed: !completed } : t)));
    }
  };

  const handleAdd = async (phaseId, title) => {
    try {
      const res = await api.post(`/projects/${project.project_id}/tasks`, { phase_id: phaseId, title, category: "Personal" });
      setTasks((ts) => [...ts, res.data]);
      await refreshProject();
    } catch {
      toast.error("No se pudo añadir la tarea.");
    }
  };

  const handleDelete = async (task) => {
    const prev = tasks;
    setTasks((ts) => ts.filter((t) => t.task_id !== task.task_id));
    try {
      await api.delete(`/tasks/${task.task_id}`);
      await refreshProject();
    } catch {
      toast.error("No se pudo eliminar la tarea.");
      setTasks(prev);
    }
  };

  return (
    <div data-testid="project-roadmap">
      <GlobalProgressSummary project={project} phases={phases} activePhase={activePhase} />
      <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-5 xl:col-span-4">
          <PhaseRoadmap phases={phases} progress={project.progress} selectedId={selectedId} onSelect={onSelect} />
        </div>
        <div className="lg:col-span-7 xl:col-span-8">
          {activePhase && (
            <PhaseTaskDetail
              phase={activePhase}
              tasks={phaseTasks}
              readOnly={!canEdit}
              onToggle={handleToggle}
              onAdd={handleAdd}
              onDelete={handleDelete}
            />
          )}
          {activePhase && (
            <PhaseDocuments
              projectId={project.project_id}
              phaseId={activePhase.id}
              canDelete={project.my_role === "administrador"}
            />
          )}
        </div>
      </div>
    </div>
  );
}
